import DataguardIncognito from "./Dashboard/DataguardIncognito";
import "./Dashboard/Dashboard.scss";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import DetailCards from "./DetailPages/DetailCard";
import DataguardDashboardHeader from "./Dashboard/DataguardDashboardHeader";
import { DateRangeSelector } from "../SysGuard/SysGuardCommonComp";
import { useSelector } from "react-redux";
import { SET_DATAGUARD_FROM_TIME_STAMP, SET_DATAGUARD_TO_TIME_STAMP } from "./Utility/DataguardConstant";
import Chip from "@material-ui/core/Chip";
import { messageConfig } from "../../components/common/commonUtilities";
import Popup from "reactjs-popup";
import WarningIcon from '@material-ui/icons/Warning';

export const DashboardMainHeader = ({ title, loc, selected, setSelected, children }) => {
  const history = useHistory();
  const globalFromTimeStamp = useSelector(
    (state) => state.DataguardReducer.fromTimeStamp
  );
  const globalToTimeStamp = useSelector(
    (state) => state.DataguardReducer.toTimeStamp
  );
  console.log(loc, "loc");
  const expand = useSelector((state) => state.sidebarReducer.expand);
  return (
    <div className= {loc === "detailsPage" ? "dashboard-title-fixed detailsPage" : "dashboard-title-fixed"}>
      <div className={`dataguard-dashboard-header${!expand ? " shrink" : ""}`}>
        <h2
          className="hdr-text"
          {...(loc === "detailsPage" && {
            onClick: () => history.push("/tenant/dataguard"),
          })}
        >
          {title}
        </h2>
        <div className="dataguard-right-header">
          <DateRangeSelector
            fromTimeStamp={globalFromTimeStamp}
            toTimeStamp={globalToTimeStamp}
            fromAction={(payload) => ({
              type: SET_DATAGUARD_FROM_TIME_STAMP,
              payload,
            })}
            toAction={(payload) => ({
              type: SET_DATAGUARD_TO_TIME_STAMP,
              payload,
            })}
            loc="DataGuard"
          />
          <DataguardIncognito />
        </div>
      </div>
      {loc === "dashboard" && (
        <div className={`dashboard-stats-container${!expand ? " shrink" : ""}`}>
          <div className="dashboard-row top-row">
            <div className="sys-guard-dashboard-main-container">
              <DataguardDashboardHeader />
            </div>
          </div>
        </div>
      )}
      {loc === "detailsPage" && (
        <>
          <div className="details-page-body-container">
            <DetailCards onSelect={setSelected} selected={selected} />
            <div className={`dashboard-row top-row ${loc}`}>
              <div className="sys-guard-dashboard-main-container detailsPage">
                <DataguardDashboardHeader loc="detailsPage" />
              </div>
            </div>
          </div>
          {children}
        </>
      )}
    </div>
  );
};

export const getPercentageValue = (val) => {
  if (!val || typeof val !== "object") return 0;
  const totalCount = Object.values(val).reduce((sum, v) => sum + (v.count || 0), 0);
  const totalAssets = Object.values(val).reduce((sum, v) => sum + (v.totalAssetsCount || 0), 0);
  if (totalAssets === 0) return 0;
  return (totalCount / totalAssets) * 100;
};


// Sort helper for plain numbers or numeric strings
export const getNumericValue = (val) => {
  if (val === "-" || val === null || val === undefined) return 0;
  if (typeof val === "number") return val;
  if (typeof val === "string" && !isNaN(Number(val.trim()))) {
    return Number(val.trim());
  }
  return 0;
};

// Sort helper for string-based columns (case-insensitive)
export const getStringValue = (val) => {
  if (val === "-" || val === null || val === undefined) return "";
  return String(val).toLowerCase();
};

// Sort helper for object values containing { key: { count } }
export const getCountSum = (val) => {
  if (!val || typeof val !== "object") return 0;
  return Object.values(val).reduce(
    (sum, v) => sum + (v?.count || 0),
    0
  );
};

// Sort helper for object values containing { key: { usersCount } }
export const getUsersCountSum = (val) => {
  if (!val || typeof val !== "object") return 0;
  return Object.values(val).reduce(
    (sum, v) => sum + (v?.usersCount || 0),
    0
  );
};

export const getSortValue = (val, columnId) => {
  if (val === "-" || val === null || val === undefined) return 0;

  if (typeof val === "object") {
    const first = Object.values(val)[0] || {};

    // For % of Public Assets (contains count & totalAssetsCount)
    if (first?.totalAssetsCount !== undefined) {
      return getPercentageValue(val);
    }

    if (first?.usersCount !== undefined) {
      return getUsersCountSum(val);
    }

    if (first?.count !== undefined) {
      return getCountSum(val);
    }
  }

  if (columnId.toLowerCase().includes("user")) {
    return getUsersCountSum(val);
  }

  if (typeof val === "string") {
    return getStringValue(val);
  }

  return getNumericValue(val);
};

const SeverityChips = ({ high = 0, medium = 0, low = 0 }) => {
  const getChipClass = (val, defaultClass) => {
    return `number severity-chip ${defaultClass}${val === 0 ? " noData" : ""}`;
  };

  return (
    <>
      <Chip
        size="medium"
        label={high}
        title={`${high} High Alerts`}
        className={getChipClass(high, "error")}
      />
      <Chip
        size="medium"
        label={medium}
        title={`${medium} Medium Alerts`}
        className={getChipClass(medium, "warning")}
      />
      <Chip
        size="medium"
        label={low}
        title={`${low} Low Alerts`}
        className={getChipClass(low, "default")}
      />
    </>
  );
};

export default SeverityChips;

export const renderRevokePopup = (
  revokePopup,
  revokeDetails,
  handleRevokePopupClose,
  handleRevokeConfirm,
  flag
) => {
  const renderMatter = () => {
    return (messageConfig(revokeDetails)[flag] || messageConfig(revokeDetails).default)();
  };
  return (
    <div className={revokePopup ? "sys-guard-backdrop" : ""}>
      {revokePopup && (
        <div>
          <Popup
            open={revokePopup}
            onClose={handleRevokePopupClose}
            modal
            closeOnDocumentClick={false}
            contentStyle={{
              padding: 0,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            overlayStyle={{
              zIndex: 1500,
            }}
          >
            <div className="revoke-popup-container">
              <div className="revoke-popup-title">Request for Confirmation</div>
              <div className="revoke-popup-message">{renderMatter()}</div>
              <div className="revoke-popup-actions">
                <button
                  className="revoke-popup-button-no"
                  onClick={() => handleRevokeConfirm()}
                >
                  Yes
                </button>
                <button
                  className="revoke-popup-button-yes"
                  onClick={handleRevokePopupClose}
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      )}
    </div>
  );
};

export const renderNotificationPopup = (
  notificationPopup,
  notificationDetails,
  handleNotificationPopupClose,
  handleNotificationConfirm
) => {
  const isEnabling = !notificationDetails?.currentState;
  const action = isEnabling ? "Enable" : "Disable";
  const policyName = notificationDetails?.policyName || "this policy";

  return (
    <div className={notificationPopup ? "sys-guard-backdrop" : ""}>
      {notificationPopup && (
        <div>
          <Popup
            open={notificationPopup}
            onClose={handleNotificationPopupClose}
            modal
            closeOnDocumentClick={false}
            contentStyle={{
              padding: 0,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            overlayStyle={{
              zIndex: 1500,
            }}
          >
            <div className="revoke-popup-container">
              <div className="revoke-popup-title">Request for Confirmation</div>
              <div className="revoke-popup-message">
                {action} notification for <strong>{policyName}</strong>?
              </div>
              <div className="revoke-popup-actions">
                <button
                  className="revoke-popup-button-yes"
                  onClick={() => handleNotificationConfirm()}
                >
                  Yes
                </button>
                <button
                  className="revoke-popup-button-no"
                  onClick={handleNotificationPopupClose}
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      )}
    </div>
  );
};

export const renderAlertActionPopup = (
  alertActionPopup,
  alertActionDetails,
  handleAlertActionPopupClose,
  handleAlertActionConfirm
) => {
  const policyName = alertActionDetails?.policyName || "this policy";

  return (
    <div className={alertActionPopup ? "sys-guard-backdrop" : ""}>
      {alertActionPopup && (
        <div>
          <Popup
            open={alertActionPopup}
            onClose={handleAlertActionPopupClose}
            modal
            closeOnDocumentClick={false}
            contentStyle={{
              padding: 0,
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            overlayStyle={{
              zIndex: 1500,
            }}
          >
            <div className="revoke-popup-container">
              <div className="revoke-popup-title">Request for Confirmation</div>
              <div className="revoke-popup-message">
                For <strong>{policyName}</strong>, you want to mark all alerts as?
                <br />
                <div className="note-container">
                  <WarningIcon className="note-ico" />
                  Action will be applied to all the unresolved alerts for this policy
                </div>
              </div>
              <div className="revoke-popup-actions">
                <button
                  className="revoke-popup-button-yes"
                  onClick={() => handleAlertActionConfirm('MARK_RESOLVED')}
                >
                  Resolve
                </button>
                <button
                  className="revoke-popup-button-no"
                  onClick={() => handleAlertActionConfirm('MARK_FALSE_POSITIVE')}
                >
                  False Positive
                </button>
                <button
                  className="revoke-popup-button-close"
                  onClick={handleAlertActionPopupClose}
                >
                  Close
                </button>
              </div>
            </div>
          </Popup>
        </div>
      )}
    </div>
  );
};